import * as Sentry from '@sentry/angular';
import { User } from '../models/auth-user.model';

export function setSentryUser(user: User): void {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalhost) return;

  Sentry.setUser({
    id: user.id,
    email: user.email,
    ip_address: '{{auto}}',
  });
}

export function clearSentryUser(): void {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (isLocalhost) return;

  Sentry.setUser(null);
}
